import { useCallback, useMemo, useState } from 'react';

import { mergeFilterUpdate } from '#/modules/commonComponents/table/listFilterKeys';
import { DEFAULT_LIST_PAGE_SIZE } from '#/utils/listUrl/listPaginationDefaults';

/**
 * 簽收選維修品項 Dialog 本地 listQuery（不寫 URL）。
 * filters 會送入 repair-item/search（欄位 filter 待後端；見 handoff 2026-10-01_01）。
 */
function useRepairItemPickerListQuery() {
  const [page, setPageState] = useState(1);
  const [pageSize, setPageSizeState] = useState(DEFAULT_LIST_PAGE_SIZE);
  const [keyword, setKeywordState] = useState('');
  const [sort, setSortState] = useState([]);
  const [userFilters, setUserFilters] = useState({});

  const listQuery = useMemo(() => ({
    page,
    pageSize,
    keyword,
    sort,
    filters: {
      ...userFilters,
    },
  }), [page, pageSize, keyword, sort, userFilters]);

  const setPage = useCallback((nextPage) => {
    setPageState(nextPage);
  }, []);

  const setPageSize = useCallback((nextPageSize) => {
    setPageSizeState(nextPageSize);
    setPageState(1);
  }, []);

  const setKeyword = useCallback((nextKeyword) => {
    setKeywordState(nextKeyword ?? '');
    setPageState(1);
  }, []);

  const setFilter = useCallback((key, value) => {
    setUserFilters((prev) => mergeFilterUpdate(prev, key, value));
    setPageState(1);
  }, []);

  const setSort = useCallback((nextSort) => {
    setSortState(nextSort ?? []);
    setPageState(1);
  }, []);

  const removeSortAt = useCallback((index) => {
    setSortState((prev) => (prev ?? []).filter((_, sortIndex) => sortIndex !== index));
    setPageState(1);
  }, []);

  const resetQuery = useCallback(() => {
    setPageState(1);
    setPageSizeState(DEFAULT_LIST_PAGE_SIZE);
    setKeywordState('');
    setSortState([]);
    setUserFilters({});
  }, []);

  return {
    listQuery,
    setPage,
    setPageSize,
    setKeyword,
    setFilter,
    setSort,
    removeSortAt,
    resetQuery,
  };
}

export default useRepairItemPickerListQuery;
